import {emptyListResponse} from "@/domain/core/utils/django"

const state = {
    // Event list
    events: {...emptyListResponse},
    hasActiveFilters: false,

    // Event creation
    regions: null,
    categories: null,
    basePlans: null,
    region: null,
    urlParams: JSON.parse(sessionStorage.getItem('event_url') || 'null'),
}

export const getters = {
    // Event list
    events: state => state.events,
    hasActiveFilters: state => state.hasActiveFilters,

    // Event creation
    regions: state => state.regions,
    region: state => state.region,
    categories: state => state.categories,
    basePlans: state => state.basePlans,
    urlSessionParams: state => state.urlParams || {},
}


export const mutations = {
    resetState(state) {
        state.events = {...emptyListResponse}
        state.hasActiveFilters = false
        state.regions = null
        state.categories = null
        state.basePlans = null
        state.region = null
        state.urlParams = null
    },
    events(state, events) {
        state.events = events
    },
    hasActiveFilters(state, hasActive) {
        state.hasActiveFilters = hasActive
    },
    regions(state, regions) {
        state.regions = regions
    },
    region(state, region) {
        state.region = region
        state.base_plans = null
    },
    categories(state, categories) {
        state.categories = categories
    },
    basePlans(state, basePlans) {
        state.basePlans = basePlans
    },
    rememberUrl(state, {region, plan, category}) {
        if (!region && !plan && !category) {
            sessionStorage.removeItem('event_url')
            state.urlParams = null
            return
        }

        const memory = {
            region: region,
            plan: plan,
            category: category
        }
        sessionStorage.setItem('event_url', JSON.stringify(memory))
        state.urlParams = memory
    },
}


export const actions = service => ({
    // Event list
    async fetchEventList({commit}, {filters, pagination, sorting}) {
        const events = await service.fetchEventList(filters, pagination, sorting)
        commit('events', events)
        // Track if any filter is active
        const hasActive = Object.values(filters).some(v => v !== '' && v !== null && v !== undefined)
        commit('hasActiveFilters', hasActive)
    },

    // Event creation
    // eslint-disable-next-line no-unused-vars
    async createNewEvent({commit}, data) {
        const newEvent = await service.createNewEvent(data)
        commit('rememberUrl', {})
        return newEvent
    },
    async fetchCreateConfig({commit, getters}, contractId = null) {
        const config = await service.fetchCreateConfig(getters['urlSessionParams'], contractId)
        if (config['region']) {
            commit('regions', null)
            commit('region', config['region'])
            commit('categories', config['categories'])
            commit('basePlans', config['base_plans'])
        } else {
            commit('region', null)
            commit('regions', config['regions'])
            commit('categories', null)
            commit('basePlans', null)
        }
    },
    async setRegion({commit}, region) {
        commit('region', region)
    },
    async fetchCategories({commit, getters}) {
        commit('categories', await service.fetchCategories(getters['region'].id))
    },
    rememberUrl({commit}, {region, plan, category}) {
        commit('rememberUrl', {region, plan, category})
    },
})

export default eventService => ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions: actions(eventService)
})
